import React from "react";

interface props {
  message?: string;
  icon?: React.ReactNode;
}

export const BasicIconCard = ({ message, icon }: props) => {
  return (
    <>
      <div className="flex items-center space-x-1 md:space-x-2">
        {icon}
        <p className="lg:uppercase font-openSans font-normal text-mobile-body-xsm md:text-web-subheading leading-3 md:leading-6 text-brand-bgBlack">
          {message}
        </p>
      </div>
    </>
  );
};

export default BasicIconCard;
